

export const labEntryColumns = [
    {
        field: "componentName",
        headerName: "Component Name",
        width: 200,
    },
   
  
   
    {
        field: "unit",
        headerName: "Unit",
        width: 200,
        
    },
    {
        field: "referenceRange",
        headerName: "Reference",
        width: 150,
    },

   
    

  
    {
        field: "testMethod",
        headerName: "Test Method",
        width: 150,
    },

   

    
];
